import axios from "axios";

const api = axios.create({
  baseURL: process.env.VUE_APP_HERMES_URL,
  timeout: 30000000,
  headers: {
    'Api-Key': process.env.VUE_APP_API_KEY_HERMES,
  }
});

export default {
  getGroupedLetters(category = null) {
    const params = {};
    if (category) params.category = category;
    return api.get("/letters/grouped", { params });
  },

  addLetter(data) {
    return api.post("/new-letter-institution", data);
  },

  updateLetters() {
    return api.post("/update/letters");
  },

  getGroupedReports(category = null) {
    const params = {};
    if (category) params.category = category;
    return api.get("/bc/grouped", { params });
  },

  updateReports() {
    return api.post("/update/bc");
  },
};
